/**
 * @module builder
 */
import type { OptionsDocument } from 'paintscout'
import uniq from 'lodash/uniq'
import type { QuoteTemplateOption } from '../index'

import { getFeature } from '../get-features'

export function getQuoteTemplateOptions(args: {
  options: OptionsDocument
  quoteType?: string
  inactive?: boolean
  canDeactivate?: boolean
}): QuoteTemplateOption[] {
  const { options, inactive, quoteType, canDeactivate = true } = args
  const { quoteTemplates } = options.options

  if (!quoteTemplates || !getFeature({ options, path: 'quotes.templates.enabled' })) {
    return []
  }

  const order =
    quoteTemplates.quoteTypeOrder && quoteTemplates.quoteTypeOrder[quoteType]
      ? uniq([...quoteTemplates.quoteTypeOrder[quoteType], ...quoteTemplates.order])
      : quoteTemplates?.order ?? []

  return order
    .map((orderItem) => {
      const item = quoteTemplates.values[orderItem]
      if (!item) {
        return null
      }

      const option: QuoteTemplateOption = {
        ...item
      }

      if (canDeactivate && !inactive && item.active !== true && typeof item.active !== 'undefined') {
        return null
      } else if (inactive) {
        option.active = typeof item.active === 'undefined' ? true : !!item.active
      }

      const quoteTypes = item.quoteTypes

      if (!quoteType || quoteType === 'all' || quoteTypes.includes('all') || quoteTypes.includes(quoteType)) {
        return {
          ...option,
          quoteTypes: option.quoteTypes?.length ? option.quoteTypes : ['all']
        }
      }

      return null
    })
    .filter((item) => item)
}
